<app-warning-modal />

<!-- Modal de Senha Temporária -->
<app-temporary-password-modal
  [email]="temporaryPasswordEmail"
  [temporaryPassword]="temporaryPassword"
  [isOpen]="showTemporaryPasswordModal"
  (onClose)="onTemporaryPasswordModalClose()"
  (onSuccess)="onTemporaryPasswordSuccess($event)">
</app-temporary-password-modal>

<!-- VERSÃO MOBILE -->
<div class="lg:hidden min-h-screen-safe relative flex flex-col">
  <!-- Imagem de fundo fullscreen -->
  <div class="absolute inset-0 bg-cover bg-center bg-no-repeat"
    style="background-image: url('assets/img/LandingPage-1.png');"></div>

  <!-- Overlay escuro -->
  <div class="absolute inset-0 bg-black/40"></div>

  <!-- Conteúdo Mobile -->
  <div class="relative z-10 flex-1 flex flex-col justify-center items-center px-6 py-12 safe-area-inset">

    <!-- Card branco -->
    <div class="w-full max-w-sm bg-white rounded-2xl p-8 shadow-2xl">

      <!-- Logo -->
      <div class="mb-8" (click)="navigateToLanding()">
        <img src="assets/icons/logo-v2.svg" class="h-6 max-w-[200px]" />
      </div>

      <!-- Título -->
      <div class="mb-8">
        <h1 class="text-2xl font-semibold text-neutral-900">
          Login
        </h1>
      </div>

      <!-- Formulário -->
      <form class="space-y-5" [formGroup]="loginForm" (ngSubmit)="onSubmitLogin($event)">
        <!-- Campo Email -->
        <div>
          <label for="email-mobile" class="block text-sm font-medium text-neutral-900 mb-2">
            Email
          </label>
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-neutral-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
            <input formControlName="email" id="email-mobile" name="email" type="email" autocomplete="email"
              placeholder="email@domain.com"
              class="block w-full pl-10 pr-4 py-3 rounded-lg border border-neutral-200 text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all duration-200 bg-white">
          </div>
        </div>

        <!-- Campo Senha -->
        <div>
          <label for="password-mobile" class="block text-sm font-medium text-neutral-900 mb-2">
            Senha
          </label>
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-neutral-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
            <input formControlName="password" id="password-mobile" name="password"
              [type]="showPassword ? 'text' : 'password'" autocomplete="current-password" placeholder="••••••"
              class="block w-full pl-10 pr-12 py-3 rounded-lg border border-neutral-200 text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all duration-200 bg-white">
            <button type="button" (click)="togglePasswordVisibility()" [attr.aria-pressed]="showPassword"
              class="absolute inset-y-0 right-0 pr-3 flex items-center text-neutral-400 hover:text-neutral-600 transition-colors">
              <svg *ngIf="!showPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <svg *ngIf="showPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="1.5">
                <path
                  d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
                </path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            </button>
          </div>
        </div>

        <!-- Lembrar de mim e Esqueci a senha -->
        <div class="flex items-center justify-between">
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="checkbox"
              class="w-4 h-4 rounded border-neutral-300 text-neutral-900 focus:ring-neutral-900 focus:ring-offset-0">
            <span class="text-sm text-neutral-600">Lembrar de mim</span>
          </label>
          <a routerLink="/forgot-password" class="text-sm text-neutral-600 hover:text-neutral-900 underline transition-colors">
            Esqueci a senha
          </a>
        </div>

        <!-- Botão de Submit -->
        <button type="submit" [disabled]="loginForm.invalid || loading" class="w-full py-3.5 px-4 rounded-full font-medium text-white transition-all duration-200 flex items-center justify-center gap-2
                 bg-neutral-900 hover:bg-neutral-800 
                 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:ring-offset-2
                 disabled:bg-neutral-300 disabled:cursor-not-allowed">
          <app-loading-spinner *ngIf="loading" size="sm"></app-loading-spinner>
          {{ loading ? 'Entrando...' : 'Entrar' }}
        </button>
      </form>

      <!-- Termos e Política -->
      <div class="mt-6 text-center">
        <p class="text-xs text-neutral-500">
          Ao continuar, você concorda com nossas<br>
          <a href="#" class="underline hover:text-neutral-700">Termos de Serviço</a> e a <a href="#"
            class="underline hover:text-neutral-700">Política de Privacidade</a>
        </p>
      </div>
    </div>
  </div>
</div>

<!-- VERSÃO DESKTOP - Layout Split -->
<div class="hidden lg:flex min-h-screen flex-row">
  <!-- Lado Esquerdo - Formulário de Login -->
  <div class="flex-1 flex flex-col justify-center items-center bg-[#efeee9]">
    <div class="w-full max-w-md flex-col gap-4 flex">
      <!-- Logo -->
      <div class="cursor-pointer" (click)="navigateToLanding()">
        <img src="assets/icons/logo-v2.svg" class="h-6 max-w-[200px]" />
      </div>
      <!-- Título -->
      <h1 class="text-3xl font-bold text-neutral-900">
        Login
      </h1>

      <!-- Formulário -->
      <form class="space-y-6" [formGroup]="loginForm" (ngSubmit)="onSubmitLogin($event)">
        <!-- Campo Email -->
        <div>
          <label for="email" class="block text-sm font-medium text-neutral-900 mb-2">
            Email
          </label>
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-neutral-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
            <input formControlName="email" id="email" name="email" type="email" autocomplete="email"
              placeholder="email@domain.com"
              class="block w-full pl-10 pr-4 py-3 rounded-lg border border-neutral-200 text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all duration-200">
          </div>
        </div>

        <!-- Campo Senha -->
        <div>
          <label for="password" class="block text-sm font-medium text-neutral-900 mb-2">
            Senha
          </label>
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-neutral-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
            <input formControlName="password" id="password" name="password" [type]="showPassword ? 'text' : 'password'"
              autocomplete="current-password" placeholder="••••••"
              class="block w-full pl-10 pr-12 py-3 rounded-lg border border-neutral-200 text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all duration-200">
            <button type="button" (click)="togglePasswordVisibility()" [attr.aria-pressed]="showPassword"
              class="absolute inset-y-0 right-0 pr-3 flex items-center text-neutral-400 hover:text-neutral-600 transition-colors">
              <!-- Ícone Olho Aberto -->
              <svg *ngIf="!showPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <!-- Ícone Olho Fechado -->
              <svg *ngIf="showPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="1.5">
                <path
                  d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
                </path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            </button>
          </div>
        </div>

        <!-- Esqueci a senha -->
        <div class="flex justify-end">
          <a routerLink="/forgot-password" class="text-sm text-neutral-600 hover:text-neutral-900 underline transition-colors">
            Esqueci a senha
          </a>
        </div>

        <!-- Botão de Submit -->
        <button type="submit" [disabled]="loginForm.invalid || loading" class="w-full py-3.5 px-4 rounded-full font-medium text-white transition-all duration-200 flex items-center justify-center gap-2
                 bg-neutral-900 hover:bg-neutral-800 
                 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:ring-offset-2
                 disabled:bg-neutral-300 disabled:cursor-not-allowed">
          <app-loading-spinner *ngIf="loading" size="sm"></app-loading-spinner>
          {{ loading ? 'Entrando...' : 'Entrar' }}
        </button>
      </form>
    </div>
  </div>

  <!-- Lado Direito - Imagem -->
  <div class="flex-1 relative overflow-hidden">
    <!-- Imagem de fundo -->
    <div class="absolute inset-0 bg-cover bg-center bg-no-repeat"
      style="background-image: url('assets/img/LandingPage-1.png');"></div>

    <!-- Overlay escuro sutil -->
    <div class="absolute inset-0 bg-black/20"></div>

    <!-- Conteúdo sobre a imagem -->
    <div class="relative z-10 flex flex-col justify-end items-start p-12 xl:p-16 pb-20 w-full h-full">
      <!-- Texto de boas-vindas -->
      <h2 class="text-5xl xl:text-6xl font-bold text-white mb-4">
        Boas-vindas
      </h2>
      <p class="text-white/90 text-base max-w-md leading-relaxed">
        Nascemos da convicção de que a segurança jurídica pode e deve fazer parte de uma boa experiência.
      </p>
    </div>
  </div>
</div>